import { Col, Flex, Row, Typography } from "antd";
import dayjs from "dayjs";

export default function QuestionContentPreview(props) {
	const {
		id = [],
		question = null,
		description = null,
		type = null,
		form_question_options = [],
		answers = {},
	} = props;

	const renderQuestionOption = () => {
		let newId = Array.isArray(id) ? id.join("_") : id;
		// console.log("renderQuestionOption newId: ", newId);
		// console.log("renderQuestionOption type: ", type);

		switch (type) {
			case "Text (Input)":
			case "Number (Input)":
			case "Date (Datepicker)":
			case "Time (Timepicker)":
			case "Radio (Button)":
			case "Checkbox":
			case "Select (Dropdown)":
				let answer = "";

				Object.keys(answers).forEach((key) => {
					if (!key.includes("_other")) {
						if (answers[key] && answers[key] !== undefined) {
							if (key === newId) {
								answer = checkTypeAnswer(type, answers[key]);
							}
						}
					}
				});

				Object.keys(answers).forEach((key) => {
					if (key.includes("_other")) {
						if (answers[key] && answers[key] !== undefined) {
							let q_id = key.split("_other")[0];
							if (q_id === newId) {
								answer += ": " + answers[key];
							}
						}
					}
				});

				let extractSubAnswerCopy = extractSubAnswer(
					type,
					newId,
					form_question_options,
				);

				if (extractSubAnswerCopy) {
					answer += extractSubAnswerCopy;
				}

				let extractSubAnswerWithSubQuestionCopy =
					extractSubAnswerWithSubQuestion(type, newId, form_question_options);

				return (
					<Flex vertical>
						{answer}
						{extractSubAnswerWithSubQuestionCopy}
					</Flex>
				);
			case "sub_question":
				return form_question_options.map((option) => {
					return (
						<Row key={`${newId}_qo_${option.id}`}>
							<Col xs={24} sm={24} lg={24} xl={24} xxl={24}>
								<Typography.Text strong>{option.option}</Typography.Text>
							</Col>
							<Col xs={24} sm={24} lg={24} xl={24} xxl={24}>
								<QuestionContentPreview
									id={[...id, `qo_${option.id}`]}
									question={option.question_option}
									type={option.sub_option_type}
									form_question_options={
										option.form_question_options.length
											? option.form_question_options
											: []
									}
									answers={answers}
								/>
							</Col>
						</Row>
					);
				});
			default:
				return null;
		}
	};

	const extractSubAnswer = (type, id, form_question_options) => {
		// console.log("extractSubAnswer: ", { type, id, form_question_options });
		switch (type) {
			case "Text (Input)":
			case "Number (Input)":
			case "Select (Dropdown)":
			case "Date (Datepicker)":
			case "Time (Timepicker)":
			case "Radio (Button)":
			case "Checkbox":
				let answer = "";

				form_question_options.forEach((option) => {
					let subanswer = answers[`${id}_qo_${option.id}`];

					if (option.sub_option_type) {
						if (subanswer) {
							answer += " - " + checkTypeAnswer(type, subanswer);
						}
						let extractSubAnswerCopy = extractSubAnswer(
							option.sub_option_type,
							`${id}_qo_${option.id}`,
							option.form_question_options,
						);

						if (extractSubAnswerCopy) {
							answer += extractSubAnswerCopy;
						}
					}
				});

				return answer;
			default:
				return null;
		}
	};
	const extractSubAnswerWithSubQuestion = (type, id, form_question_options) => {
		switch (type) {
			case "sub_question":
				return form_question_options.map((option) => {
					return (
						<Row key={`${id}_qo_${option.id}`}>
							<Col xs={24} sm={24} lg={24} xl={24} xxl={24}>
								<Typography.Text strong>{option.option}</Typography.Text>
							</Col>
							<Col xs={24} sm={24} lg={24} xl={24} xxl={24}>
								<QuestionContentPreview
									id={[...id, `qo_${option.id}`]}
									question={option.question_option}
									type={option.sub_option_type}
									form_question_options={
										option.form_question_options.length
											? option.form_question_options
											: []
									}
									answers={answers}
								/>
							</Col>
						</Row>
					);
				});
			default:
				return null;
		}
	};

	const checkTypeAnswer = (type, answer) => {
		switch (type) {
			case "Text (Input)":
			case "Number (Input)":
			case "Select (Dropdown)":
				return answer;
			case "Date (Datepicker)":
				return answer ? dayjs(answer).format("MM/DD/YYYY") : null;
			case "Time (Timepicker)":
				return answer ? dayjs(answer).format("HH:mm:ss") : null;
			case "Radio (Button)":
				return answer;
			case "Checkbox":
				return answer.join(", ");
			default:
				return null;
		}
	};

	return (
		<Row>
			{question ? (
				<Col xs={24} sm={24} md={24} lg={24} xl={24}>
					<div
						className="quill-output question"
						dangerouslySetInnerHTML={{
							__html: question,
						}}
					/>
					{description && <div className="description">{description}</div>}
				</Col>
			) : null}

			<Col
				xs={24}
				sm={24}
				md={24}
				lg={24}
				xl={24}
				style={Array.isArray(id) ? { paddingLeft: 20 } : {}}
			>
				{renderQuestionOption()}
			</Col>
		</Row>
	);
}
